// 本地登录
function localLoginURL() {
    return "/login.html#/";
}

// 蓝鲸登录
function blueLoginURL() {
    let domain = "http://paas.cros.garena.com";
    switch (document.domain) {
        case "vlink.cros.garena.com":
            domain = "http://paas.cros.garena.com";
            break;
    }
    const redirect = document.location.href;
    return `${domain}/login/?c_url=${redirect}`;
}

export const getLoginUrl = () => {
    if (process.env.VUE_APP_FUNC_LOGIN_WAY === "blue") {
        return blueLoginURL();
    } else {
        return localLoginURL();
    }
};

export const useToken = (() => {
    if (process.env.VUE_APP_FUNC_LOGIN_WAY === "blue") {
        return false;
    } else {
        return true;
    }
})();
